<template>
  <InputAuto
    ref="sug"
    v-model="selected"
    :template="template"
    :scope="scope"
    :errorsBag="errorsBag"
    :label="label"
    :name="name"
    :isLoading="isLoading"
    :sugestoes="sugestoes"
    :disabled="habilitarCampo()"
    :camposMostrarInput="['codigo', 'nome']"
    :camposFiltrar="['codigo', 'nome']"
    :erroConexao="erroConexao"
    :rotaTelaCadastro="'rota-filiais-cadastro'"
    separador=" - "
    msgSemRegistros='Não há filiais cadastradas...' />
</template>

<script>
import InputAuto from '@/components/inputs/autocomplete/InputAuto.vue'
import InputAutoMixin from '@/components/inputs/autocomplete/InputAutoMixin'

import TemplateFilial from './templates/TemplateFilial.vue'
import FiliaisService from '../../../services/filiais.service'

export default {
  name: 'InputSugestaoFilial',
  mixins: [InputAutoMixin],
  components: {
    InputAuto,
  },
  data() {
    return {
      template: TemplateFilial,
    }
  },
  methods: {
    async carregaTudo() {
      try {
        this.erroConexao = false
        this.isLoading = true
        const retorno = await FiliaisService.retornaTodosSemLimite()
        this.sugestoes = retorno.lista
      } catch (error) {
        this.erroConexao = error.tipo === 'MSG_ERRO'
        this.sugestoes = []
      } finally {
        this.isLoading = false
      }
    },
  },
}

</script>
